import { webUrls } from 'appConstants';
import { claimJobChat } from 'redux/actions';

export const handleNavItemClick = ({ route, history }) => history.push(route);

export const handleTenDLCFormClick = (handleShowScheduleMessageModal) =>
  handleShowScheduleMessageModal(true);

export const handleChatClick = ({ chat, history, dispatch, navigationRoutes }) => {
  const { id: chatId, jobChatId, threadId } = chat;

  dispatch(claimJobChat({ jobChatUuid: jobChatId, chatId }));

  history.push({
    pathname: navigationRoutes.myInbox,
    state: { thread: { ...chat, id: threadId } },
  });
};

export const handleClaimAllChatClick = async ({
  history,
  navigationRoutes,
  unClaimedChats,
  dispatch,
}) => {
  await Promise.all(
    unClaimedChats.map(async (chat) => {
      await dispatch(claimJobChat({ jobChatUuid: chat.jobChatId, chatId: chat.id }));
    }),
  );

  history.push(navigationRoutes.myInbox);
};

export const handleHelpOnClick = () => window.open(webUrls.HELP_CENTER, '_blank', 'noopener');

export const handleUnreadMessageClick = ({ threadData, navigationRoutes, tabletView, history }) => {
  if (tabletView) {
    // redirects to `Candidate Profile` only view
    history.push(`${navigationRoutes.myInbox}/${threadData.candidateId}`);
  } else {
    // redirects to `Candidate Profile` and `Inbox` view in desktop view.
    history.push({ pathname: navigationRoutes.myInbox, state: { thread: { ...threadData } } });
  }
};

export const handleViewAllUnreadClick = ({ history, navigationRoutes }) =>
  history.push({ pathname: navigationRoutes.myInbox });

export const handleMenuIconClick = ({ value, windowStore, userName }) => {
  windowStore.setUserNavPreference(userName, !value);
};
